<template>
    <div class="contact">
        <header class="header--empty"></header>
        <regional-offices v-bind:slug="slug" />
    </div>
</template>

<script>
import RegionalOffices from "../components/RegionalOffices.vue";
export default {
    name: "contact",
    data() {
        return {
            blocks: null,
            page: null,
            better_featured_image: undefined
        };
    },
    components: {
        RegionalOffices
    },
    created: function() {
        this.$root.dataReady = false;
        this.$root.headeriswhite = false;
    },
    mounted: function() {
        this.fetchContactMap();
    },
    props: ["slug"],
    methods: {
        fetchContactMap: function() {
            var self = this;

            $.get(
                this.$root.apiUrl + "wp-json/wp/v2/pages?slug=" + self.slug,
                function(response) {
                    self.mapsRepeater =
                        response[0].acf.block_grid[2]["maps-repeater"];
                    self.page = response[0];
                    self.setTitle(response[0].title.rendered);
                    self.$root.dataReady = true;

                    $("div.wpcf7 > form").each(function() {
                        var $form = $(this);
                        wpcf7.init($form[0]);
                        if (wpcf7.cached) {
                            wpcf7.refill($form);
                        }
                    });
                }
            );
        },
        setTitle: function(title) {
            title = title.normalize('NFD').replace("&#038;", "&");
            document.title = title + " - Weber Shandwick";
        }
    }
};
</script>



// WEBPACK FOOTER //
// Contact.vue?29ffa1b1